import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import Weekday from "./weekday";
import { semanticColors } from "../../Globals/styles";

class Employee extends Component {
  getHeight = () => {
    const { employee } = this.props;
    var maxHeight = 0;
    Object.keys(employee.weekdays).forEach((weekdayIndex) => {
      if (
        employee.weekdays[weekdayIndex].bookingItems.length +
        employee.weekdays[weekdayIndex].stickyNotes.length >
        maxHeight
      ) {
        maxHeight =
          employee.weekdays[weekdayIndex].bookingItems.length +
          employee.weekdays[weekdayIndex].stickyNotes.length;
      }
    });
    return maxHeight;
  };

  render() {
    const {
      onWorkplaceDrop,
      onStickynoteDrop,
      employee,
      isStartOfWeek,
      workplaces,
      openEditBookingModal,
      openEditStickyNoteModal,
      goToDagrapport,
      isCompressed,
    } = this.props;
    var maxHeight = this.getHeight();
    let weekdayNodes = [];
    Object.keys(employee.weekdays).forEach((weekdayIndex, index) => {
      // pending bookings
      let pendingBookings = [];
      let bookings = [];
      //get the workplaces from the workplaces collection
      employee.weekdays[weekdayIndex].bookingItems.forEach((booking) => {
        var w = workplaces[booking.workplaceId];
        if (w === undefined) {
          pendingBookings.push(booking);
        } else bookings.push({ ...w, ...booking });
      });

      weekdayNodes.push(
        <div key={index} style={[styles.weekdayContainer]} className="col-xs-3">
          <Weekday
            maxHeight={maxHeight}
            index={index}
            onStickynoteDrop={() => onStickynoteDrop(index)}
            onWorkplaceDrop={(workplace) => onWorkplaceDrop(workplace, index)}
            openEditBookingModal={(bookingIndex) =>
              openEditBookingModal(bookingIndex, index)
            }
            openEditStickyNoteModal={(stickynoteIndex) =>
              openEditStickyNoteModal(stickynoteIndex, index)
            }
            goToDagrapport={goToDagrapport}
            workplaces={bookings}
            pendingBookings={pendingBookings}
            isCompressed={isCompressed}
            stickynotes={employee.weekdays[weekdayIndex].stickyNotes}
          />
        </div>
      );
    });

    return (
      <div style={styles.container}>
        <h2 style={styles.employeeName}>{employee.name}</h2>
        {weekdayNodes}
      </div>
    );
  }
}

var styles = {
  container: {
    backgroundColor: semanticColors.default,
    height: "100%",
    marginBottom: "10px",
    float: "right",
    width: "100%",
    overflowX: "hidden",
  },
  employeeName: {
    fontSize: "14px",
    paddingLeft: "20px",
    paddingBottom: "10px",
  },
  weekdayContainer: {
    height: "100%",
    borderRight: "1px solid " + semanticColors.mainBackground,
    display: "inline-block",
    width: "14%",
  },
  noBorder: {
    borderRight: "none",
  },
};
Employee.propTypes = {
  onWorkplaceDrop: PropTypes.func.isRequired,
  onStickynoteDrop: PropTypes.func.isRequired,
  employee: PropTypes.object.isRequired,
  isStartOfWeek: PropTypes.bool.isRequired,
  workplaces: PropTypes.object.isRequired,
  openEditBookingModal: PropTypes.func.isRequired,
  openEditStickyNoteModal: PropTypes.func.isRequired,
  goToDagrapport: PropTypes.func.isRequired,
  isCompressed: PropTypes.bool.isRequired,
};
export default Radium(Employee);



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/employee.jsx